/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ExternalTicketWithoutSerialNumberCreateDto } from '../../models/external-ticket-without-serial-number-create-dto';

export interface TicketControllerCreateExternalTicketWithoutSerialNumber$Params {
      body: ExternalTicketWithoutSerialNumberCreateDto
}

export function ticketControllerCreateExternalTicketWithoutSerialNumber(http: HttpClient, rootUrl: string, params: TicketControllerCreateExternalTicketWithoutSerialNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, ticketControllerCreateExternalTicketWithoutSerialNumber.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: BaseResponse;
      }>;
    })
  );
}

ticketControllerCreateExternalTicketWithoutSerialNumber.PATH = '/ticket/external-ticket-without-serial';
